import {
  CreateUserMutation,
  InstructorsQuery,
  UpdateUserMutation,
} from "src/api/User";
import { withApi, withApiMutation } from "src/stores/Api";

export const UpdateUser = withApiMutation(UpdateUserMutation, {
  name: "updateUser",
});

export const CreateUser = withApiMutation(CreateUserMutation, {
  name: "createUser",
});

export const QueryInstructors = withApi(InstructorsQuery, {
  name: "queryInstructors",
  skip: ({ visible }) => {
    if (typeof visible === "boolean") {
      return !visible;
    }
  },
  options: ({ store }: any) => {
    return {
      variables: { organizationId: store.organization.id },
    };
  },
});
